
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'GlobalStyles',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/GlobalStyles/GlobalStyles.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PackingMaterialsList',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/PackingMaterialList/PackingMaterialsList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NordicFlyer',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/NordicFlyer/NordicFlyer.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Header',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Header/Header.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Datasheet',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Datasheet/Datasheet.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Cover',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Cover/Cover.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Footer',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Footer/Footer.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SnackbarManager',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Snackbars/SnackbarManager/SnackbarManager.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'TradesProductListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TradesProductListing/TradesProductListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedProducts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TabbedProducts/TabbedProducts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedTools',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TabbedTools/TabbedTools.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/SteelStorageConfigurator/SteelStorageConfigurator.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ToolFinder',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ToolFinder/ToolFinder.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SearchResults',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/SearchResults/SearchResults.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollingHotSpotBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ScrollingHotSpotBanner/ScrollingHotSpotBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'REDemptionCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/REDemptionCards/REDemptionCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductRangeRoot',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductRange/ProductRangeRoot.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductListRange',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductListRange/ProductListRange.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductListing/ProductListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductGallery/ProductGallery.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetailPopUp',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductDetailPopUp/ProductDetailPopUp.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LegacyManualsAndSparePartsButton',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductDetailPopUp/LegacyManualsAndSparePartsButton.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductCarousel/ProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductCards/ProductCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductAttachmentSelector',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductAttachmentSelector/ProductAttachmentSelector.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEPillarsOfSafety',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/PPEPillarsOfSafety/PPEPillarsOfSafety.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PlatinumServiceSearch',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/PlatinumServiceSearch/PlatinumServiceSearch.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/NewProductCarousel/NewProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewProductCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/NewProductCards/NewProductCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelProductDownloads',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MxFuelProductDownloads/MxFuelProductDownloads.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MxFuelProductComparison',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MxFuelProductComparison/MxFuelProductComparison.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelProductHero',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MXFuelProductHero/MxFuelProductHero.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXCalculator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MXCalculator/MXCalculator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InteractiveRange',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/InteractiveRange/InteractiveRange.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Interactive360Image',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/Interactive360Image/Interactive360Image.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GroupedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/GroupedProductCarousel/GroupedProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeProductCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ForgeProductCards/ForgeProductCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeProductCallouts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ForgeProductCallouts/ForgeProductCallouts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HotspotProductRange',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/HotspotProductRange/HotspotProductRange.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FoamInsertsConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FoamInsertsConfigurator/FoamInsertsConfigurator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FibblRenderer',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FibblRenderer/FibblRenderer.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FindYourCharger',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FindYourCharger/FindYourCharger.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeatureProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FeatureProductCarousel/FeatureProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DrainCleanersKitBuilder',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/DrainCleanersKitBuilder/DrainCleanersKitBuilder.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DetailedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/DetailedProductCarousel/DetailedProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AlgoliaSearchResults',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/AlgoliaSearchResults/AlgoliaSearchResults.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccessorySelector',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/AccessorySelector/AccessorySelector.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'UnderstandingTheFeatures',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/UnderstandingTheFeatures/UnderstandingTheFeatures.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StoreLocatorCTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/StoreLocatorCTA/StoreLocatorCTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WhatsIncluded',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/WhatsIncluded/WhatsIncluded.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductToolOverview',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductToolOverview/ProductToolOverview.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSuggestions',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductSuggestions/ProductSuggestions.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSpecifications',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductSpecifications/ProductSpecifications.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductReviewsListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductReviews/ProductReviewsListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductNavigation/ProductNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductFeaturesText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductFeaturesText/ProductFeaturesText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductFAQs',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductFAQs/ProductFAQs.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetailVideos',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductDetailVideos/ProductDetailVideos.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetails',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductDetails/ProductDetails.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Hotspot360',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Hotspot360/Hotspot360.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Downloads',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Downloads/Downloads.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ComboKitFeatures',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ComboKitFeatures/ComboKitFeatures.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CareIcons',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/CareIcons/CareIcons.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ApplicationGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ApplicationGallery/ApplicationGallery.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Bolt100ThreeKitConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Bolt100ThreeKitConfigurator/Bolt100ThreeKitConfigurator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesStickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/TradesStickyNavigation/TradesStickyNavigation.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Bolt200ThreeKitConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Bolt200ThreeKitConfigurator/Bolt200ThreeKitConfigurator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesAlternateStickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/TradesAlternateStickyNavigation/TradesAlternateStickyNavigation.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/StickyNavigation/StickyNavigation.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InnerNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/InnerNavigation/InnerNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'YoutubeShortsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/YoutubeShortsCarousel/YoutubeShortsCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoSeekerCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoSeekerCarousel/VideoSeekerCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoCarousel/VideoCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoWithText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoWithText/VideoWithText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/TradeCards/TradeCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TestimonialSlider',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/TestimonialSlider/TestimonialSlider.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/SystemCards/SystemCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageInteractiveVideosWrapper',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/SteelStorageInteractiveVideosWrapper/SteelStorageInteractiveVideosWrapper.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ShortsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ShortsCarousel/ShortsCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ScrollCarousel/ScrollCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEJobsite',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/PPEJobsite/PPEJobsite.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXFuelVideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MXFuelVideoCarousel/MXFuelVideoCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXFuelSplitVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MXFuelSplitVideoBanner/MXFuelSplitVideoBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MultiImageSignpostBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MultiImageSignpostBanner/MultiImageSignpostBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingPreview',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/LightingPreview/LightingPreview.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LaserAnimation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/LaserAnimation/LaserAnimation.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InteractiveVideo',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/InteractiveVideo/InteractiveVideo.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageSlider',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ImageSlider/ImageSlider.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ImageGallery/ImageGallery.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HotspotCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/HotspotCards/HotspotCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GalleryWithNav',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/GalleryWithNav/GalleryWithNav.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthVideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FullWidthVideoCarousel/FullWidthVideoCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FootwearInteractiveVideo',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FootwearInteractiveVideo/FootwearInteractiveVideo.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FilteredGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FilteredGallery/FilteredGallery.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'DrainCleanersApplication',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/DrainCleanersApplication/DrainCleanersApplication.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentVideo',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ContentVideo/ContentVideo.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CentredCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CentredCarousel/CentredCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventMap',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/EventMap/EventMap.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CategoryCards/CategoryCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CareersMap',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CareersMap/CareersMap.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CookiePopup',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Misc/CookiePopup/CookiePopup.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PushForPrizesCampaign',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/CompetitionGiveaways/PushForPrizesCampaign/PushForPrizesCampaign.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VirtualTourAccess',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/VirtualTourAccess/VirtualTourAccess.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SignUp',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/SignUp/SignUp.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PromotionSignUpPopUp',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionSignUpPopUp/PromotionSignUpPopUp.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SignUpStacked',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/SignUpStacked/SignUpStacked.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PromotionForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionForm/PromotionForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PromotionAddressCollectionForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionAddressCollectionForm/PromotionAddressCollectionForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PreferencesFormSalesforce',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PreferencesFormSalesforce/PreferencesFormSalesforce.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewsletterSignUp',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/NewsletterSignUp/NewsletterSignUp.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PopupSignUp',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PopupSignUp/PopupSignUp.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PackoutSubmission',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PackoutSubmission/PackoutSubmission.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MasterContactForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/MasterContactForm/MasterContactForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'JSSRegistration',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/JSSRegistration/JSSRegistration.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'JSSProductReviews',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/JSSProductReviews/JSSProductReviews.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HubRegistration',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/HubRegistration/HubRegistration.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventRegistrationForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/EventRegistrationForm/EventRegistrationForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventNDAForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/EventNDAForm/EventNDAForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BlitzForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/BlitzForm/BlitzForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BigRedForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/BigRedForm/BigRedForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ConfigurableCompetitionForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/ConfigurableCompetitionForm/ConfigurableCompetitionForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CompetitionForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/CompetitionForm/CompetitionForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WhatsNewBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/WhatsNewBanner/WhatsNewBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AdvancedEventRegistrationForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/AdvancedEventRegistrationForm/AdvancedEventRegistrationForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'VideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/VideoBanner/VideoBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoToneBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TwoToneBanner/TwoToneBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VerticalCarouselBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/VerticalCarouselBanner/VerticalCarouselBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeHeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradeHeroBanner/TradeHeroBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesInnerBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradesInnerBanner/TradesInnerBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradeBanner/TradeBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TextBanner/TextBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StandardsBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/StandardsBanner/StandardsBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SocialLinks',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SocialLinks/SocialLinks.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitContentBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SplitContentBanner/SplitContentBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost6040',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/Signpost6040/Signpost6040.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SocialBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SocialBanner/SocialBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollingTextBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ScrollingTextBanner/ScrollingTextBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'REDemptionBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/REDemptionBanner/REDemptionBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PPEBanner/PPEBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PinBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PinBanner/PinBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ParallaxBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ParallaxBanner/ParallaxBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OutdoorBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/OutdoorBanner/OutdoorBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/MxFuelVideoBanner/MxFuelVideoBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PageBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PageBanner/PageBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MultiplePinBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/MultiplePinBanner/MultiplePinBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'M12M18Banner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/M12M18Banner/M12M18Banner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LogoBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LogoBanner/LogoBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LightingBanner/LightingBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LeadingBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LeadingBanner/LeadingBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LasersBanner/LasersBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LargeBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LargeBanner/LargeBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InnerBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/InnerBanner/InnerBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputLandingBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/HighOutputLandingBanner/HighOutputLandingBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthBannerWithContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FullWidthBannerWithContent/FullWidthBannerWithContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FullWidthVideoBanner/FullWidthVideoBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FuelBanner/FuelBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventDateBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/EventDateBanner/EventDateBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ContentBanner/ContentBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AspectRatioBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/AspectRatioBanner/AspectRatioBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Banner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/Banner/Banner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ZeroEmissions',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ZeroEmissions/ZeroEmissions.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'XC5ProductFeature',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/XC5ProductFeature/XC5ProductFeature.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WarrantyBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/WarrantyBanner/WarrantyBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoToneContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TwoToneContent/TwoToneContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'UpcomingEvents',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/UpcomingEvents/UpcomingEvents.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TripleText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TripleText/TripleText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TripleImageSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TripleImageSplitContent/TripleImageSplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoColumnText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TwoColumnText/TwoColumnText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeTestimonialCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeTestimonialCarousel/TradeTestimonialCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeDownloadsListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeDownloadsListing/TradeDownloadsListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeCardListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeCardListing/TradeCardListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeArticleListingPreview',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeArticleListingPreview/TradeArticleListingPreview.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeApplicationProductListingPreview',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeApplicationProductListingPreview/TradeApplicationProductListingPreview.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TieredPinSelector',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TieredPinSelector/TieredPinSelector.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextWithGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TextWithGallery/TextWithGallery.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextWithFullWidthImage',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TextWithFullWidthImage/TextWithFullWidthImage.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedCTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TabbedCTA/TabbedCTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsSignposts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsSignposts/SystemsSignposts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemSelector',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemSelector/SystemSelector.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsChargerCTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsChargerCTA/SystemsChargerCTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemFooterBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemFooterBanner/SystemFooterBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsShowcaseDuo',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsShowcaseDuo/SystemsShowcaseDuo.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StepByStepContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StepByStepContent/StepByStepContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StoreLocator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StoreLocator/StoreLocator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageFeatures',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SteelStorageFeatures/SteelStorageFeatures.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StaticHtml',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StaticHtml/StaticHtml.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StaggeredContentCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StaggeredContentCarousel/StaggeredContentCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Staggered5050SplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Staggered5050SplitContent/Staggered5050SplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitCTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SplitCTA/SplitCTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitAnchorCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SplitAnchorCards/SplitAnchorCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SignpostCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SignpostCarousel/SignpostCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SimpleCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SimpleCards/SimpleCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost7030',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Signpost7030/Signpost7030.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost5050',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Signpost5050/Signpost5050.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ServiceCentreLocator',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ServiceCentreLocator/ServiceCentreLocator.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RepeatContentScroll',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/RepeatContentScroll/RepeatContentScroll.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSEOCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductSEOCarousel/ProductSEOCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollingCallouts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ScrollingCallouts/ScrollingCallouts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductLandingProducts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductLandingProducts/ProductLandingProducts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductFeatures',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductFeatures/ProductFeatures.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCarouselWithBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductCarouselWithBanner/ProductCarouselWithBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPESupportingContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PPESupportingContent/PPESupportingContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPESplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PPESplitContent/PPESplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PneumaticVsCordless',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PneumaticVsCordless/PneumaticVsCordless.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PageLanguageSelector',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PageLanguageSelector/PageLanguageSelector.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PackoutSignpost',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PackoutSignpost/PackoutSignpost.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OnlineBlitzSteps',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/OnlineBlitzSteps/OnlineBlitzSteps.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NumberedCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NumberedCards/NumberedCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OneKeySignpost',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/OneKeySignpost/OneKeySignpost.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NumberedBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NumberedBanner/NumberedBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NailersFeatures',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NailersFeatures/NailersFeatures.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelZeroEmissions',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelZeroEmissions/MxFuelZeroEmissions.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Newsletter',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Newsletter/Newsletter.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelIcons',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelIcons/MxFuelIcons.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelBenefits',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelBenefits/MxFuelBenefits.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelHoverProduct',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelHoverProduct/MxFuelHoverProduct.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelAnimatedScroll',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelAnimatedScroll/MxFuelAnimatedScroll.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MX4HotspotComparison',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MX4HotspotComparison/MX4HotspotComparison.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'M18SystemComparison',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/M18SystemComparison/M18SystemComparison.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'M18FuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/M18FuelBanner/M18FuelBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'M18ForgeFeature',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/M18ForgeFeature/M18ForgeFeature.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersTabbedOverview',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersTabbedOverview/LasersTabbedOverview.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LayeredDualImageBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LayeredDualImageBanner/LayeredDualImageBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LightingContent/LightingContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersRange',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersRange/LasersRange.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersPreviewVideos',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersPreviewVideos/LasersPreviewVideos.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersOverviewIcons',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersOverviewIcons/LasersOverviewIcons.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersIntroduction',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersIntroduction/LasersIntroduction.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersDemoCta',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersDemoCta/LasersDemoCta.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersComparisonVideo',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersComparisonVideo/LasersComparisonVideo.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'KeyFeaturesShowcase',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/KeyFeaturesShowcase/KeyFeaturesShowcase.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IntroductionText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IntroductionText/IntroductionText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageWithBorder',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ImageWithBorder/ImageWithBorder.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageGrid',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ImageGrid/ImageGrid.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IconWithText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IconWithText/IconWithText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HtmlContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HtmlContent/HtmlContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IconBar',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IconBar/IconBar.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputSplitContent/HighOutputSplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputLetterboxSection',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputLetterboxSection/HighOutputLetterboxSection.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputGraphs',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputGraphs/HighOutputGraphs.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighlightedFeaturesProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighlightedFeaturesProductCarousel/HighlightedFeaturesProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeatedGearTabbed',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HeatedGearTabbed/HeatedGearTabbed.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeatedGearIcon',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HeatedGearIcon/HeatedGearIcon.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HandtoolsGuarantee',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HandtoolsGuarantee/HandtoolsGuarantee.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GuaranteeSplitDetailCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/GuaranteeSplitDetailCards/GuaranteeSplitDetailCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GenericImageText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/GenericImageText/GenericImageText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthText/FullWidthText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthImageFeature',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthImageFeature/FullWidthImageFeature.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthContentCTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthContentCTA/FullWidthContentCTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeWalkaround',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeWalkaround/ForgeWalkaround.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeTabbedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeTabbedProductCarousel/ForgeTabbedProductCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSizeCalloutScrollJack',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSizeCallout/ForgeSizeCalloutScrollJack.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSizeCallout',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSizeCallout/ForgeSizeCallout.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSignpost',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSignpost/ForgeSignpost.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgePowerScale',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgePowerScale/ForgePowerScale.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeRuntimeCallouts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeRuntimeCallouts/ForgeRuntimeCallouts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeMXFuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeMXFuelBanner/ForgeMXFuelBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCooling',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCooling/ForgeCooling.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCoolCycleFlow',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCoolCycleFlow/ForgeCoolCycleFlow.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeChargeComparisonTable',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeChargeComparisonTable/ForgeChargeComparisonTable.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCellTechnologies',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCellTechnologies/ForgeCellTechnologies.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FiftyFiftyDetailedContentAccordion',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FiftyFiftyDetailedContentAccordion/FiftyFiftyDetailedContentAccordion.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeChargeCallouts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeChargeCallouts/ForgeChargeCallouts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeaturedPanel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FeaturedPanel/FeaturedPanel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FAQList',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FAQList/FAQList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ExtendedText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ExtendedText/ExtendedText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DualImageAndText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DualImageAndText/DualImageAndText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DualProductCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DualProductCards/DualProductCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DrainCleanersSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DrainCleanersSplitContent/DrainCleanersSplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DownloadListing/DownloadListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DownloadCards/DownloadCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DetailedCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DetailedCards/DetailedCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CtaImageGrid',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CtaImageGrid/CtaImageGrid.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CTA',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CTA/CTA.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CountdownTimer',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CountdownTimer/CountdownTimer.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentGeneral',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ContentGeneral/ContentGeneral.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ColourRenderingContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ColourRenderingContent/ColourRenderingContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ChargeTimeTable',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ChargeTimeTable/ChargeTimeTable.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ChargeTimeRange',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ChargeTimeRange/ChargeTimeRange.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CentreText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CentreText/CentreText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CareersSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CareersSplitContent/CareersSplitContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CarouselCardsWithText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CarouselCardsWithText/CarouselCardsWithText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CategoryListing/CategoryListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CalloutCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CalloutCards/CalloutCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Callout5050',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Callout5050/Callout5050.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BazaarSocialGallery',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/BazaarSocialGallery/BazaarSocialGallery.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BatteryTypeCards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/BatteryTypeCards/BatteryTypeCards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AuthorisedDistributor',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AuthorisedDistributor/AuthorisedDistributor.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Accordion',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Accordion/Accordion.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AboutUsCallout',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AboutUsCallout/AboutUsCallout.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AboutUsTimeline',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AboutUsTimeline/AboutUsTimeline.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TeesterTracking',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/TeesterTracking/TeesterTracking.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ScrollToTop',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/ScrollToTop/ScrollToTop.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ParamsAnchor',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/ParamsAnchor/ParamsAnchor.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Loader',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/Loader/Loader.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Video',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/Video/Video.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SocialShareIcons',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/SocialShareIcons/SocialShareIcons.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentHubTestimonialSlider',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/TestimonialSlider/ContentHubTestimonialSlider.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RichText',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/RichText/RichText.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RelatedContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/RelatedContent/RelatedContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Stats',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/Stats/Stats.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InteractiveInfographicSlider',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/InteractiveInfographicSlider/InteractiveInfographicSlider.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Testimonial',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/Testimonial/Testimonial.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageContentBlock',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/ImageContentBlock/ImageContentBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/HeroBanner/HeroBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeaturedContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/FeaturedContent/FeaturedContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeatureExplainerBlocks',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/FeatureExplainerBlocks/FeatureExplainerBlocks.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FAQs',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/FAQs/FAQs.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadBlock',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/DownloadBlock/DownloadBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CTABannerWidget',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/CTABannerWidget/CTABannerWidget.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/ContentListing/ContentListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ComparisonTable',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/ComparisonTable/ComparisonTable.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryGrid',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/CategoryGrid/CategoryGrid.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CaseStudies',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/CaseStudies/CaseStudies.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Awards',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/Awards/Awards.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AnchorNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Widgets/AnchorNavigation/AnchorNavigation.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RichTextElement',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Elements/RichText/RichTextElement.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FilterDropdown',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Elements/FilterDropdown/FilterDropdown.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Pagination',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Pagination/Pagination.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FilterSort',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/FilterSort/FilterSort.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NavigationTypeahead',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Components/Search/NavigationTypeahead/NavigationTypeahead.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductList',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Components/Products/ProductList/ProductList.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductFinder',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Components/Products/ProductFinder/ProductFinder.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersPopupForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Components/Forms/LasersPopupForm/LasersPopupForm.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GenericPopup',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Components/Content/GenericPopup/GenericPopup.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'WishlistListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/WishlistListing/WishlistListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'TradeTitleSection',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/TradeTitleSection/TradeTitleSection.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/SteelStorageListing/SteelStorageListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RecentlyViewedListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/RecentlyViewedListing/RecentlyViewedListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'QuickLinksPods',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/QuickLinksPods/QuickLinksPods.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RecentlyViewed',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/RecentlyViewed/RecentlyViewed.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PromotionBanner',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/PromotionBanner/PromotionBanner.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OwnedToolsListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/OwnedToolsListing/OwnedToolsListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'NewsListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/NewsListing/NewsListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/NewsCarousel/NewsCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MyPackoutListing',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/MyPackoutListing/MyPackoutListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewInProducts',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/NewInProducts/NewInProducts.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MyInventoryTabbed',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/MyInventoryTabbed/MyInventoryTabbed.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MyClaims',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/MyClaims/MyClaims.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DataCaptureLoginForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/DataCaptureLoginForm/DataCaptureLoginForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'BubblehouseFormListeners',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/BubblehouseFormListeners/BubblehouseFormListeners.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccountSignInForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/AccountSignInForm/AccountSignInForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccountSettings',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/AccountSettings/AccountSettings.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccountNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/AccountNavigation/AccountNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccountForgotPasswordForm',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/AccountForgotPasswordForm/AccountForgotPasswordForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccountFAQs',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/AccountArea/Widgets/AccountFAQs/AccountFAQs.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingCalculatorWidget',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/LightingCalculator/LightingCalculatorWidget/LightingCalculatorWidget.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StandardsContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/StandardsContent/StandardsContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RespiratorsContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/RespiratorsContent/RespiratorsContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SafetyGlassesContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/SafetyGlassesContent/SafetyGlassesContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'KneePadsContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/KneePadsContent/KneePadsContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HearingProtectionContent',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/HearingProtectionContent/HearingProtectionContent.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PressReleaseListingRoot',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PressRelease/PressReleaseListing/PressReleaseListingRoot.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PressReleaseDetail',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PressRelease/PressReleaseDetail/PressReleaseDetail.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadCard',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Cards/DownloadCard/DownloadCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeatureExplainerBlockCard',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Cards/FeatureExplainerBlockCard/FeatureExplainerBlockCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentCard',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Cards/ContentCard/ContentCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryCard',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Cards/CategoryCard/CategoryCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AwardCard',
  import: (): Promise<any> => import('C:/agent/_work/3405/s/CMS/SiteFiles/next-gen/src/stories/ContentHub/Components/Cards/AwardCard/AwardCard.client'),
  config: {
    hydrate: 'in-view',
  },
} 
];
  